import { createSlice } from "@reduxjs/toolkit";
import accountContext from "./accountContext";
import { AccountState } from "./models/AccountModels";

const initialState: AccountState = {
  user: accountContext.user,
  accessToken: accountContext.accessToken
};

const accountSlice = createSlice({
  name: "account",
  initialState: initialState,
  reducers: {
    refreshAccount: (state, payload) => {
      state.user = accountContext.user;
      state.accessToken = accountContext.accessToken;
    },
    updateUser: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    }
  }
});

export const {
  refreshAccount,
  updateUser
} = accountSlice.actions;

export default accountSlice.reducer;